import { Link, type LinkProps } from "react-router-dom";
import type { ReactNode } from "react";
import { buttonClass, type ButtonClassOptions } from "@/shared/components/Button";

type ButtonLinkProps = Omit<LinkProps, "to"> & {
  to?: string;
  href?: string;
  children: ReactNode;
  className?: string;
};

export function ButtonLink({
  children,
  className,
  to,
  href,
  ...props
}: ButtonLinkProps & ButtonClassOptions) {
  return (
    <Link
      {...props}
      to={(to ?? href) as string}
      className={buttonClass({
        variant: props.variant,
        size: props.size,
        shape: props.shape,
        fullWidth: props.fullWidth,
        className,
      })}
    >
      {children}
    </Link>
  );
}
